import { render, staticRenderFns } from "./ContactFields.vue?vue&type=template&id=5ac8d435&scoped=true"
import script from "./ContactFields.vue?vue&type=script&lang=js"
export * from "./ContactFields.vue?vue&type=script&lang=js"
import style0 from "./ContactFields.vue?vue&type=style&index=0&id=5ac8d435&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac8d435",
  null
  
)

export default component.exports